// extracted by mini-css-extract-plugin
export default {"text_transform":"Button_text_transform__wGP6s","btnGlobal":"Button_btnGlobal__F3ecK"};